export const MAX_WIDTH = 800